import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.task_overlay.task_id',
  })

  return {
    variables: {
      id,
    },
    pause: !id,
  }
}
